import React, { useState,useEffect } from "react";
import { useParams,Link,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";

import { addThousandPoint,ChangeSimpleDateString,isNull } from "../../components/common/Common";

import "../../css/style.css";

//정산세부내역
const SettlementDetail = () => {
  const { st_idx } = useParams();
  const navigate = useNavigate();
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varSettlementsInfo,setSettlementsInfo] = useState({});
  const [varMamaMonteList,setMamaMonteList] = useState([]);
  const [varFlyList,setFlyListFly] = useState([]);
  const [varOtherList,setOtherList] = useState([]);

  //정산세부내역 호출
  const GetSettlementInformation = async() => {
    const sendData = {st_idx:st_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_settlement_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      setSettlementsInfo(datas.settlements[0]);
      setMamaMonteList(datas.mamamontes);
      setFlyListFly(datas.flys);
      setOtherList(datas.others);
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    GetSettlementInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  
  //정산승인
  /* const onApprovalSettlementHandler = async(e) => {
    const sendData = {st_idx:st_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_settlement_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        navigate('/Branch/SettlementSet');
      } else {
        alert(datas.message);
      }
    });
  } */

  //교재내역보기
  const onGotoTextBookHandler = (e,sobj) => {
    if(sobj.stl_vs_idx === 3) {
      navigate(`/Branch/TextBookShow/${st_idx}/${sobj.st_year+'-'+sobj.st_month}`);
    }
  }

  return (
    <div className="vh-content settle-content">
      <HeaderBranchTitle varPageTitle={'정산 상세'} varBackString={'/Branch/SettlementSet'}/>
      <div className="vh-content-body">
        <div className="settle-view-wrap">
          <div className="center-wrap">
            <div className="settle-top-line">
              <div className="view-tit">
                <p>{`${varSettlementsInfo.st_year}.${varSettlementsInfo.st_month}월`} 정산 요청서</p>
                <p>정산 총액 : {addThousandPoint(varSettlementsInfo.st_amount)}원</p>
              </div>
              <div className={varSettlementsInfo.st_status===3?"display-payment2":"display-payment1"}>{varSettlementsInfo.st_status===3?"납부":"미납"}</div>
            </div>

            {/* 마마몽떼 */}
            <div className="settle-info">
							<div className="info">
								<div className="flex">
									<p>총 청구 인원</p>
									<div>{varSettlementsInfo.total_childrens}명</div>
								</div>
								<div className="flex">
									<p>총 월별 로열티</p>
									<div>{addThousandPoint(varSettlementsInfo.total_royalty)}원</div>
								</div>
							</div>
							<div className="info">
								<div className="flex">
									<p>마마몽떼 인원</p>
									<div>{isNull(varSettlementsInfo.mama_childrens)?0:varSettlementsInfo.mama_childrens}명</div>
								</div>
								<div className="flex">
									<p>총 마마몽떼 로열티</p>
									<div>{addThousandPoint(varSettlementsInfo.mama_royalty)}원</div>
								</div>
							</div>
						</div>
            <table id="">
              <thead>
								<tr>
									<th>인원</th><th>클래스</th><th>신규<br/>로열티</th><th>학부모</th><th>원생</th><th>수업<br/>차수</th>
								</tr>
							</thead>
              <tbody>
                {varMamaMonteList.map((mamas,i)=>(
                  <tr key={'mamas_'+i}>
                    <td>{i+1}</td>
                    <td>{mamas.cl_name}</td>
                    <td>{addThousandPoint(mamas.stl_price)}</td>
                    <td>{mamas.mem_name}</td>
                    <td>{mamas.ch_name}</td>
                    <td>{mamas.ycount}/{mamas.tstudys}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {/* 플라이 */}
            <div className="settle-info">
              <div className="info">
                <div className="flex">
                  <p>플라이 인원</p>
                  <div>{isNull(varSettlementsInfo.fly_childrens)?0:varSettlementsInfo.fly_childrens}명</div>
                </div>
                <div className="flex">
                  <p>총 플라이 로열티</p>
                  <div>{addThousandPoint(varSettlementsInfo.fly_royalty)}원</div>
                </div>
              </div>
            </div>
            <table id="">
              <thead>
								<tr>
									<th>인원</th><th>클래스</th><th>신규<br/>로열티</th><th>학부모</th><th>원생</th><th>수업<br/>차수</th>
								</tr>
							</thead>
              <tbody>
                {varFlyList.map((flys,i)=>(
                  <tr key={'flys_'+i}>
                    <td>{i+1}</td>
                    <td>{flys.cl_name}</td>
                    <td>{addThousandPoint(flys.stl_price)}</td>
                    <td>{flys.mem_name}</td>
                    <td>{flys.ch_name}</td>
                    <td>{flys.ycount}/{flys.tstudys}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {/* 수시로얄티 */}
            <div className="settle-info">
              <div className="info">
                <div className="flex">
                  <p>수시 로얄티</p>
                  <div>{addThousandPoint(varSettlementsInfo.other_royalty)}원</div>
                </div>
              </div>
            </div>
            <table id="">
              <thead>
								<tr>
									<th>목록</th><th>내용</th><th>수량</th><th>가격</th><th>제공일시</th>
								</tr>
							</thead>
              <tbody>
                {varOtherList.map((others,i)=>(
                  <tr key={'others_'+i} onClick={e=>onGotoTextBookHandler(e,others)}>
                    <td style={others.stl_vs_idx===3?{backgroundColor:"#eee"}:{backgroundColor:"#fff"}}>{others.vs_name}</td>
                    <td style={others.stl_vs_idx===3?{backgroundColor:"#eee"}:{backgroundColor:"#fff"}}>{others.stl_info}</td>
                    <td style={others.stl_vs_idx===3?{backgroundColor:"#eee"}:{backgroundColor:"#fff"}}>{isNull(others.stl_numb)||others.stl_numb===0?"1":others.stl_numb}</td>
                    <td style={others.stl_vs_idx===3?{backgroundColor:"#eee"}:{backgroundColor:"#fff"}}>{addThousandPoint(others.stl_amount)}</td>
                    <td style={others.stl_vs_idx===3?{backgroundColor:"#eee"}:{backgroundColor:"#fff"}}>{ChangeSimpleDateString(others.stl_sdate)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            <div className="form-contoller bt-btn">
              {varSettlementsInfo.st_status===1?
                <>
                  <Link to={'/Branch/SettlementSet'} style={{width:"100%"}} className="form-contoller-btn btn-no">취소</Link>
                  {/* <button  className="form-contoller-btn btn-yes" onClick={e=>onApprovalSettlementHandler(e)}>정산 승인</button> */}
                </>
              :
                <Link to={'/Branch/SettlementSet'} style={{width:"100%"}} className="form-contoller-btn btn-no">목록</Link>
              }
						</div>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default SettlementDetail;